"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("./_internal/utils");
var isString_1 = tslib_1.__importDefault(require("./isString"));
var reduce_1 = tslib_1.__importDefault(require("./reduce"));
function sync(sep, iterable) {
    var res = (0, reduce_1.default)(function (a, b) { return (a == "" ? "".concat(b) : "".concat(a).concat(sep).concat(b)); }, "", iterable);
    if (res == null) {
        return "";
    }
    return (0, isString_1.default)(res) ? res : String(res);
}
function async(sep, iterable) {
    return (0, reduce_1.default)(function (a, b) { return (a == "" ? "".concat(b) : "".concat(a).concat(sep).concat(b)); }, "", iterable).then(function (res) {
        if (res == null) {
            return "";
        }
        return (0, isString_1.default)(res) ? res : String(res);
    });
}
function join(sep, iterable) {
    if (iterable === undefined) {
        return function (iterable) {
            return join(sep, iterable);
        };
    }
    if (Array.isArray(iterable) && iterable.length === 0)
        return "";
    if ((0, utils_1.isIterable)(iterable)) {
        return sync(sep, iterable);
    }
    if ((0, utils_1.isAsyncIterable)(iterable)) {
        return async(sep, iterable);
    }
    throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
exports.default = join;
//# sourceMappingURL=join.js.map